export default __webpack_public_path__ + "static/media/ppisignet.dd60aeeb.png";